import { State } from '../../reducers/rootReducer'
import EquipmentGroup from '../../../entities/EquipmentGroup'

const equipmentGroupsSelector = (state: State): EquipmentGroup[] => state.equipmentGroups

export default equipmentGroupsSelector
